import { notification } from 'antd'

export const clipboard = (text: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text)

    notification.success({
      message: `Текст "${text}" скопирован в буфер обмена`,
    })
  } else {
    notification.error({
      message: 'Ошибка',
      description: 'Буфер обмена не поддерживается на Вашем устройстве',
    })
  }
}
